import axios from "axios";
const GetUsers = async (uri, emailAddress) => {
  try {
    const userEmail = localStorage.getItem(
      "login-app-user-email"
    );
    if (userEmail === emailAddress) {
      return true;
    } else {
      const { data } = await axios.get(`${uri}`);
      const keys = [];
      const allEmailAddress = [];
      for (const key in data) {
        keys.push(key);
        allEmailAddress.push(
          data[key].emailAddress
        );
      }
      if (
        allEmailAddress.indexOf(emailAddress) ===
        -1
      ) {
        localStorage.removeItem(
          "login-app-user-email"
        );
        return false;
      } else {
        localStorage.setItem(
          "login-app-user-email",
          emailAddress
        );
        return true;
      }
    }
  } catch (error) {
    throw new Error(error.message);
  }
};

export default GetUsers;
